import TranslateMessage from '../../../i18n/TranslateMessage';

export default {
  phone: TranslateMessage('MursionPortal.Support.PhoneNumber'),
  email: 'support@mursion.com',
  hours: TranslateMessage('MursionPortal.Error.Time'),
  link: 'https://support.mursion.com',
};